(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ac-image-comparison-v2')) {
    customElements.define(
      'ac-image-comparison-v2',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();

          const signal = this.controller.signal;
          let activePointer = null;

          const update = input => {
            const value = Math.max(
              0,
              Math.min(100, Number(input.value))
            );

            this.style.setProperty(
              '--compare-position',
              `${value}%`
            );

            input.setAttribute(
              'aria-valuetext',
              `Antes: ${value}% — Depois: ${100 - value}%`
            );
          };

          const move = event => {
            const input = this.querySelector('.ac-compare-range');
            const bounds = this.getBoundingClientRect();

            if (!input || bounds.width === 0) return;

            input.value = Math.round(
              Math.max(
                0,
                Math.min(
                  100,
                  ((event.clientX - bounds.left) / bounds.width) * 100
                )
              )
            );

            update(input);
          };

          this.addEventListener(
            'pointerdown',
            event => {
              if (!event.isPrimary || event.button !== 0) return;

              const input = this.querySelector('.ac-compare-range');
              if (!input) return;

              event.preventDefault();

              activePointer = event.pointerId;
              this.setPointerCapture(event.pointerId);

              input.focus({ preventScroll: true });
              move(event);
            },
            { signal, passive: false }
          );

          this.addEventListener(
            'pointermove',
            event => {
              if (event.pointerId !== activePointer) return;

              event.preventDefault();
              move(event);
            },
            { signal, passive: false }
          );

          const end = event => {
            if (event.pointerId !== activePointer) return;

            if (event.type === 'pointerup') {
              move(event);
            }

            activePointer = null;

            if (this.hasPointerCapture(event.pointerId)) {
              this.releasePointerCapture(event.pointerId);
            }
          };

          this.addEventListener('pointerup', end, { signal });
          this.addEventListener('pointercancel', end, { signal });

          this.addEventListener(
            'lostpointercapture',
            () => {
              activePointer = null;
            },
            { signal }
          );

          this.addEventListener(
            'input',
            event => {
              if (event.target.matches('.ac-compare-range')) {
                update(event.target);
              }
            },
            { signal }
          );

          this.addEventListener(
            'change',
            event => {
              if (event.target.matches('.ac-compare-range')) {
                update(event.target);
              }
            },
            { signal }
          );

          requestAnimationFrame(() => {
            if (signal.aborted || !this.isConnected) return;

            const input = this.querySelector('.ac-compare-range');

            if (input) update(input);
          });
        }

        disconnectedCallback() {
          this.controller?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amparo-cart"]) return;
  try {
    
  (function () {
    if (window.AmparoCart) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var el = function () { return document.querySelector('amparo-cart'); };
    var lastFocus = null;
    var muting = false;

    function setCounts(n) {
      document.querySelectorAll('[data-pca-count],[data-apd-count]').forEach(function (e) { e.textContent = n; e.hidden = !n; });
    }
    function refresh() {
      var c = el();
      if (!c) return Promise.resolve();
      c.classList.add('is-busy');
      return fetch(root + '?sections=amparo-cart', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var doc = new DOMParser().parseFromString(j['amparo-cart'] || '', 'text/html');
          var fresh = doc.querySelector('[data-acart-content]');
          var cur = c.querySelector('[data-acart-content]');
          if (fresh && cur) {
            cur.innerHTML = fresh.innerHTML;
            setCounts(Number(fresh.getAttribute('data-acart-count')) || 0);
          }
        })
        .catch(function () {})
        .finally(function () { c.classList.remove('is-busy'); });
    }
    function open() {
      var c = el();
      if (!c) return false;
      if (c.hidden) {
        lastFocus = document.activeElement;
        c.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(function () { c.classList.add('is-open'); });
      }
      refresh().then(function () { var x = c.querySelector('.acart__x'); if (x) x.focus(); });
      return true;
    }
    function close() {
      var c = el();
      if (!c || c.hidden) return;
      c.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { c.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    window.AmparoCart = { open: open, close: close, refresh: refresh };

    document.addEventListener('click', function (e) {
      var c = el();
      if (c && c.contains(e.target)) {
        if (e.target.closest('[data-acart-close]')) return close();
        var q = e.target.closest('[data-acart-key]');
        if (q) {
          c.classList.add('is-busy');
          fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: q.dataset.acartKey, quantity: Number(q.dataset.acartQ) }),
          }).finally(refresh);
          return;
        }
        if (e.target.closest('[data-acart-checkout]')) {
          if (typeof window.yampiClick === 'function') window.yampiClick();
          else window.location.href = root + 'checkout';
        }
        return;
      }
      /* Ícones de carrinho do cabeçalho abrem este carrinho em vez da página /cart */
      var o = e.target.closest('[data-pca-cart-open],[data-apd-cart-open],[data-amparo-cart-open],a[href="/cart"],a[href="' + root + 'cart"]');
      if (o && open()) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    /* Quando um carrinho antigo (Horizon, PCA ou APD) tenta abrir, ele fecha e este abre no lugar */
    function takeOver() {
      if (muting) return;
      muting = true;
      var hz = document.querySelector('#cart-drawer');
      var hzDialog = hz && hz.querySelector('dialog');
      if (hzDialog && hzDialog.open) {
        if (typeof hz.close === 'function') hz.close(); else hzDialog.close();
        open();
      }
      document.querySelectorAll('[data-pca-drawer],[data-apd-drawer]').forEach(function (d) {
        if (!d.hidden) {
          d.hidden = true;
          open();
        }
      });
      muting = false;
    }
    function watch() {
      var targets = [];
      var hz = document.querySelector('#cart-drawer dialog');
      if (hz) targets.push(hz);
      document.querySelectorAll('[data-pca-drawer],[data-apd-drawer]').forEach(function (d) { targets.push(d); });
      var mo = new MutationObserver(takeOver);
      targets.forEach(function (t) { mo.observe(t, { attributes: true, attributeFilter: ['open', 'hidden'] }); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
    else watch();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amparo-pix"]) return;
  try {
    
  (function () {
    if (window.__amparoPix) return;
    window.__amparoPix = true;

    function cents(text) {
      var m = String(text || '').match(/(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/g);
      if (!m) return 0;
      var last = m[m.length - 1].replace(/\./g, '').replace(',', '.');
      return Math.round(parseFloat(last) * 100);
    }
    function money(c) {
      return 'R$ ' + (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    /* Valor do que o cliente vai comprar agora: kit marcado ou, sem kit, o preço do produto */
    function currentTotal() {
      var sel = [
        '[data-b2-tier][aria-checked="true"] [data-b2-total]',
        '[data-apd-kit][aria-checked="true"] [data-apd-kit-total]',
        '.amp-kit-card:has(input:checked) [data-price]',
        '[data-pca-kit][aria-checked="true"] [data-pca-kit-total]',
        '[data-pca-price]',
        '[data-apd-price]',
      ];
      for (var i = 0; i < sel.length; i++) {
        var el = document.querySelector(sel[i]);
        if (el && cents(el.textContent) > 0) return cents(el.textContent);
      }
      return 0;
    }
    function anchor() {
      var a = document.querySelector('.pca-price') || document.querySelector('.apd-price');
      if (a) return { el: a, where: 'afterend' };
      var kit = document.querySelector('amparo-kit-offers-v2');
      if (kit) return { el: kit, where: 'afterbegin' };
      return null;
    }
    function paint(box) {
      var total = currentTotal();
      if (!total) return;
      var off = Number(box.dataset.off) || 0;
      var n = Number(box.dataset.n) || 1;
      var pix = box.querySelector('[data-apix-pix]');
      var parc = box.querySelector('[data-apix-parc]');
      if (pix) pix.textContent = money(Math.round((total * (100 - off)) / 100));
      if (parc) parc.textContent = money(Math.round(total / n));
    }
    function init() {
      var tpl = document.getElementById('amparo-pix-template');
      var a = anchor();
      if (!tpl || !a || document.querySelector('[data-apix]')) return;
      a.el.insertAdjacentHTML(a.where, tpl.innerHTML);
      var box = document.querySelector('[data-apix]');
      paint(box);
      var timer = null;
      var mo = new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          if (box.contains(list[i].target)) return;
        }
        clearTimeout(timer);
        timer = setTimeout(function () { paint(box); }, 60);
      });
      var root = document.querySelector('main') || document.body;
      mo.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-checked', 'checked'] });
      document.addEventListener('change', function () { setTimeout(function () { paint(box); }, 60); });
      document.addEventListener('click', function () { setTimeout(function () { paint(box); }, 120); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pca-main-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pca-video-card-v2')) {
  customElements.define('pca-video-card-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.opener = this.querySelector('[data-pca-video-open]');
      this.dialog = this.querySelector('[data-pca-video-dialog]');
      this.player = this.querySelector('[data-pca-video-player]');
      this.template = this.querySelector('[data-pca-video-template]');
      this.status = this.querySelector('[data-pca-video-status]');
      if (!this.opener || !this.dialog || !this.template || typeof this.dialog.showModal !== 'function') return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.opener.setAttribute('role', 'button');
      this.opener.setAttribute('aria-haspopup', 'dialog');
      this.opener.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.openVideo();
      }, options);
      this.opener.addEventListener('keydown', (event) => {
        if (event.key === ' ') { event.preventDefault(); this.openVideo(); }
      }, options);
      this.querySelector('[data-pca-video-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.releaseVideo();
        if (this.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('cancel', () => this.releaseVideo(), options);
      this.dialog.addEventListener('keydown', (event) => event.stopPropagation(), options);
      document.addEventListener('shopify:block:select', (event) => {
        if (this.dialog.open && !this.contains(event.target)) this.dialog.close();
      }, options);
    }
    openVideo() {
      if (this.dialog.open) return;
      document.querySelectorAll('pca-video-card-v2').forEach((card) => {
        if (card !== this && card.dialog && card.dialog.open) card.dialog.close();
      });
      this.player.replaceChildren(this.template.content.cloneNode(true));
      this.status.hidden = true;
      this.video = this.player.querySelector('video');
      this.dialog.showModal();
      if (!this.video) return;
      const activeVideo = this.video;
      activeVideo.addEventListener('error', () => {
        if (this.video !== activeVideo) return;
        this.status.textContent = this.status.dataset.error;
        this.status.hidden = false;
      }, { once: true });
      activeVideo.addEventListener('playing', () => { this.status.hidden = true; });
      const pending = activeVideo.play();
      if (pending) pending.catch(() => {
        if (this.video !== activeVideo || !this.dialog.open) return;
        this.status.textContent = activeVideo.error ? this.status.dataset.error : this.status.dataset.fallback;
        this.status.hidden = false;
      });
    }
    releaseVideo() {
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
        this.video.load();
        this.video = null;
      }
      if (this.player) this.player.replaceChildren();
    }
    disconnectedCallback() {
      if (this.events) this.events.abort();
      this.events = null;
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.releaseVideo();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amparo-complementary-section')) {
    customElements.define(
      'amparo-complementary-section',
      class extends HTMLElement {
        connectedCallback() {
          this.controller?.abort();
          this.controller = new AbortController();

          const signal = this.controller.signal;

          this.addEventListener('change', event => {
            if (event.target.matches('[data-variant]')) {
              this.updateVariant(event.target.closest('[data-card]'));
            }
          }, { signal });

          this.addEventListener('click', event => this.click(event), {
            signal
          });

          this.addEventListener('submit', event => this.submit(event), {
            signal
          });

          requestAnimationFrame(() => {
            if (signal.aborted || !this.isConnected) return;

            this.setup();

            if (this.dataset.ready === 'false' && this.dataset.product) {
              this.load(signal);
            }
          });
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.observer?.disconnect();
        }

        setup() {
          this.querySelectorAll('[data-card]').forEach(card => {
            this.updateVariant(card);
          });

          this.track = this.querySelector('[data-track]');
          this.observer?.disconnect();

          if (this.track) {
            this.track.addEventListener(
              'scroll',
              () => this.navigation(),
              {
                passive: true,
                signal: this.controller.signal
              }
            );

            this.observer = new ResizeObserver(() => this.navigation());
            this.observer.observe(this.track);
            this.navigation();
          }
        }

        async load(signal) {
          try {
            const url = new URL(this.dataset.url, location.origin);

            url.searchParams.set('section_id', this.dataset.section);
            url.searchParams.set('product_id', this.dataset.product);
            url.searchParams.set('intent', this.dataset.intent);
            url.searchParams.set('limit', this.dataset.limit);

            const response = await fetch(url, { signal });

            if (!response.ok) throw new Error('recommendations');

            const html = new DOMParser().parseFromString(
              await response.text(),
              'text/html'
            );

            const incoming = html.getElementById(this.id);

            if (!incoming || incoming.dataset.ready === 'false') {
              throw new Error('recommendations');
            }

            this.innerHTML = incoming.innerHTML;
            this.dataset.ready = 'true';
            this.setup();
          } catch (error) {
            if (error.name === 'AbortError') return;

            const loading = this.querySelector('.au-loading');
            if (loading) loading.remove();
          }
        }

        updateVariant(card) {
          const option = card.querySelector('[data-variant]')
            ?.selectedOptions[0];

          if (!option) return;

          const data = option.dataset;

          card.querySelector('[data-price]').textContent = data.price;

          const compare = card.querySelector('[data-compare]');
          compare.textContent = data.compare;
          compare.hidden = data.sale !== 'true';

          const image = card.querySelector('img.au-image');

          if (
            image &&
            data.image &&
            image.getAttribute('src') !== data.image
          ) {
            image.removeAttribute('srcset');
            image.src = data.image;
          }

          card.querySelectorAll('[data-product-link]').forEach(link => {
            link.href = data.url;
          });

          const quantity = card.querySelector('[name="quantity"]');

          quantity.min = data.min;
          quantity.step = data.step;

          if (data.max) {
            quantity.max = data.max;
          } else {
            quantity.removeAttribute('max');
          }

          quantity.value = data.min;

          const submit = card.querySelector('[data-submit]');

          submit.disabled = data.available !== 'true';
          submit.textContent = submit.disabled
            ? submit.dataset.sold
            : submit.dataset.label;

          card.querySelector('[data-status]').textContent = '';
          card.querySelector('[data-cart-link]').hidden = true;
        }

        navigation() {
          const nav = this.querySelector('[data-nav]');
          if (!nav || !this.track) return;

          const overflow =
            this.track.scrollWidth - this.track.clientWidth;

          nav.hidden = overflow < 2;

          nav.querySelector('[data-direction="-1"]').disabled =
            this.track.scrollLeft < 2;

          nav.querySelector('[data-direction="1"]').disabled =
            this.track.scrollLeft >= overflow - 2;
        }

        click(event) {
          const stepper = event.target.closest('[data-step]');

          if (stepper?.tagName === 'BUTTON') {
            const input = stepper.closest('[data-card]')
              .querySelector('[name="quantity"]');

            if (!input.value || !input.validity.valid) {
              input.value = input.min;
            }

            if (stepper.dataset.step === '1') {
              input.stepUp();
            } else {
              input.stepDown();
            }

            input.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          }

          const arrow = event.target.closest('[data-direction]');

          if (arrow && this.track) {
            const gap = parseFloat(
              getComputedStyle(this.track).gap || '0'
            );

            this.track.scrollBy({
              left: Number(arrow.dataset.direction)
                * (this.track.clientWidth + gap),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'instant'
                : 'smooth'
            });
          }
        }

        async submit(event) {
          const form = event.target;

          if (!form.matches('.au-form')) return;

          event.preventDefault();
          event.stopPropagation();

          if (form.dataset.busy || !form.reportValidity()) return;

          const button = form.querySelector('[data-submit]');
          const status = form.querySelector('[data-status]');
          const controls = [
            ...form.querySelectorAll('input,select,button')
          ];

          const previous = controls.map(control => control.disabled);
          const body = new FormData(form);

          form.dataset.busy = 'true';

          controls.forEach(control => {
            control.disabled = true;
          });

          button.textContent = this.dataset.adding;
          status.textContent = '';
          status.removeAttribute('data-error');
          form.setAttribute('aria-busy', 'true');

          let added;

          try {
            const response = await fetch(this.dataset.addUrl, {
              method: 'POST',
              body,
              headers: {
                Accept: 'application/json'
              }
            });

            const data = await response.json();

            if (!response.ok || data.status) {
              throw new Error(
                data.description || data.message || this.dataset.error
              );
            }

            added = data;
            status.textContent = this.dataset.added;
            form.querySelector('[data-cart-link]').hidden = false;
          } catch (error) {
            status.setAttribute('data-error', '');

            status.textContent = error.message === 'Failed to fetch'
              ? this.dataset.error
              : error.message;
          } finally {
            controls.forEach((control, index) => {
              control.disabled = previous[index];
            });

            button.textContent = button.dataset.label;
            delete form.dataset.busy;
            form.removeAttribute('aria-busy');
          }

          if (added) {
            this.refreshCart(added).catch(() => {});
          }
        }

        async refreshCart(added) {
          const response = await fetch(this.dataset.cartUrl, {
            headers: {
              Accept: 'application/json'
            }
          });

          if (!response.ok) return;

          const cart = await response.json();

          this.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.id,
              data: {
                source: 'amparo-complementary-section',
                itemCount: cart.item_count
              }
            }
          }));

          this.dispatchEvent(new CustomEvent('amparo:cart-added', {
            bubbles: true,
            detail: {
              cart,
              added
            }
          }));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
